<div class="header">
  <div class="header-container">
    <div class="logo">
      <img src="images/logo.svg" alt="Logo">
    </div>
    <div class="top-nav-links">
      <span>{{ 'GENERAL.TITLE' | translate }}</span>
    </div>
  </div>
</div>